/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest
 */
export interface FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest
     */
    Game: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest(value: object): value is FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSON(json: any): FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest {
    return FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
    };
}

export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON(json: any): FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest {
    return FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSONTyped(value?: FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
    };
}

